export interface PrintReceiptResult {
    isSuccess: boolean;
    errorMessage: string;

    printerStatusCode: PrinterStatusCode;
}

export enum PrinterStatusCode {
    OnlineAndReady,
    Offline,
    NoPaper,
    OtherError
}